/* eslint-disable max-len */
import getObjectAttributeFromStringKey from '@/common-utils/functions/getObjectAttributeFromStringKey';
import { client } from '../../../../../../common-utils/libraries/axios/axios';
import { buildUrl } from '@/common-utils/functions/restUtils';
import generateNestedFieldAccessor from '@/common-utils/functions/generateNestedFieldAccessor';
import PAYLUDD_SUBSCRIPTIONS from '../apiUrls';
import payluddSubscriptionFields from '../../fields/payluddSubscriptionFields';

/**
 * @param responseData response.data object
 * @param responseData.items array of payludd subscription items
 * @param responseData.totalResults number
 * @returns Mapped data object
 */
function mapResponseData({ items, totalResults }) {
    const data = {};
    const mappedItems = items.map(item => {
        return {
            [payluddSubscriptionFields.CONTRACT_ACCESS.key]: {
                [payluddSubscriptionFields.CONTRACT_ACCESS.EMAIL.key]: getObjectAttributeFromStringKey(item, generateNestedFieldAccessor(payluddSubscriptionFields.CONTRACT_ACCESS.EMAIL)),
                [payluddSubscriptionFields.CONTRACT_ACCESS.LABEL.key]: getObjectAttributeFromStringKey(item, generateNestedFieldAccessor(payluddSubscriptionFields.CONTRACT_ACCESS.LABEL))
            },
            [payluddSubscriptionFields.ORGANIZATION.key]: item[payluddSubscriptionFields.ORGANIZATION.key],
            [payluddSubscriptionFields.PACKAGE.key]: {
                [payluddSubscriptionFields.PACKAGE.CODE.key]: getObjectAttributeFromStringKey(item, generateNestedFieldAccessor(payluddSubscriptionFields.PACKAGE.CODE)),
                [payluddSubscriptionFields.PACKAGE.DOWNLOADED_AT.key]: getObjectAttributeFromStringKey(item, generateNestedFieldAccessor(payluddSubscriptionFields.PACKAGE.DOWNLOADED_AT)),
                [payluddSubscriptionFields.PACKAGE.STATUS.key]: getObjectAttributeFromStringKey(item, generateNestedFieldAccessor(payluddSubscriptionFields.PACKAGE.STATUS)),
                [payluddSubscriptionFields.PACKAGE.LABEL.key]: getObjectAttributeFromStringKey(item, generateNestedFieldAccessor(payluddSubscriptionFields.PACKAGE.LABEL)),
                [payluddSubscriptionFields.PACKAGE.VERSION.key]: getObjectAttributeFromStringKey(item, generateNestedFieldAccessor(payluddSubscriptionFields.PACKAGE.VERSION))
            },
            [payluddSubscriptionFields.POS_TERMINAL.key]: {
                [payluddSubscriptionFields.POS_TERMINAL.DIRECT_PROVIDER.key]: getObjectAttributeFromStringKey(item, generateNestedFieldAccessor(payluddSubscriptionFields.POS_TERMINAL.DIRECT_PROVIDER)),
                [payluddSubscriptionFields.POS_TERMINAL.LABEL.key]: getObjectAttributeFromStringKey(item, generateNestedFieldAccessor(payluddSubscriptionFields.POS_TERMINAL.LABEL)),
                [payluddSubscriptionFields.POS_TERMINAL.LAST_CONNECTION_DATE.key]: getObjectAttributeFromStringKey(item, generateNestedFieldAccessor(payluddSubscriptionFields.POS_TERMINAL.LAST_CONNECTION_DATE)),
                [payluddSubscriptionFields.POS_TERMINAL.MANUFACTURER.key]: getObjectAttributeFromStringKey(item, generateNestedFieldAccessor(payluddSubscriptionFields.POS_TERMINAL.MANUFACTURER)),
                [payluddSubscriptionFields.POS_TERMINAL.MODEL.key]: getObjectAttributeFromStringKey(item, generateNestedFieldAccessor(payluddSubscriptionFields.POS_TERMINAL.MODEL)),
                [payluddSubscriptionFields.POS_TERMINAL.SERIAL_NUMBER.key]: getObjectAttributeFromStringKey(item, generateNestedFieldAccessor(payluddSubscriptionFields.POS_TERMINAL.SERIAL_NUMBER))
            },
            [payluddSubscriptionFields.POS_TERMINAL_SUBSCRIPTION.key]: {
                [payluddSubscriptionFields.POS_TERMINAL_SUBSCRIPTION.UUID.key]: getObjectAttributeFromStringKey(item, generateNestedFieldAccessor(payluddSubscriptionFields.POS_TERMINAL_SUBSCRIPTION.UUID)),
                [payluddSubscriptionFields.POS_TERMINAL_SUBSCRIPTION.STATUS.key]: getObjectAttributeFromStringKey(item, generateNestedFieldAccessor(payluddSubscriptionFields.POS_TERMINAL_SUBSCRIPTION.STATUS))
            },
            [payluddSubscriptionFields.VERSION.key]: {
                [payluddSubscriptionFields.VERSION.ANDROID.key]: getObjectAttributeFromStringKey(item, generateNestedFieldAccessor(payluddSubscriptionFields.VERSION.ANDROID)),
                [payluddSubscriptionFields.VERSION.PAX.key]: getObjectAttributeFromStringKey(item, generateNestedFieldAccessor(payluddSubscriptionFields.VERSION.PAX)),
                [payluddSubscriptionFields.VERSION.PAYLUDD.key]: getObjectAttributeFromStringKey(item, generateNestedFieldAccessor(payluddSubscriptionFields.VERSION.PAYLUDD))
            }
        };
    });

    data.items = mappedItems;
    data.totalResults = totalResults;
    return data;
}

const queryGetPayluddSubscriptions = (query, enabled) => {
    return {
        queryKey: [PAYLUDD_SUBSCRIPTIONS.COLLECTION.queryKey, query],
        queryFn: async () => {
            const response = await client.get(buildUrl(PAYLUDD_SUBSCRIPTIONS.COLLECTION.url, query));
            return mapResponseData(response.data);
        },
        enabled: enabled
    };
};


export default queryGetPayluddSubscriptions;